import Vue from 'vue'
import Router from 'vue-router'

// import HelloWorld from '@/components/HelloWorld'
const HelloWorld = () => import('../components/HelloWorld')
const login = () => import('../components/login.vue')
const forgotPassword = () => import('../components/forgotPassword.vue')
const register = () => import('../components/register.vue')
const dashboard = () => import('../components/dashboard.vue')
const account = () => import('../components/Account.vue')
const pageSetup = () => import('../components/PagesSetup.vue')
const vipStatus = () => import('../components/vipStatus.vue')
const promotions = () => import('../components/promotions.vue')
const campaigns = () => import('../components/campaigns.vue')
const PermanentCampaigns = () => import('../components/PermanentCampaigns.vue')
const clients = () => import('../components/clients.vue')
const Staff = () => import('../components/Staff.vue')
const client = () => import('../components/client.vue')
const promotion = () => import('../components/promotion.vue')
const addPromotion = () => import('../components/addPromotion.vue')
const impersonate = () => import('../components/impersonate.vue')
const registerImpersonate = () => import('../components/registerImpersonate.vue')
const SmsReceived = () => import('../components/SmsReceived.vue')
const ReviewSiteLinks = () => import('../components/ReviewSiteLinks')
const StarReviewSettings = () => import('../components/StarReviewSettings')
const Reviews = () => import('../components/reviews')
const newCampaign = () => import('../components/newCampaign')
const editCampaign = () => import('../components/editCampaign')
const Affiliate = () => import('../components/Affiliate')
const OwnerOrAffiliate = () => import('../components/OwnerOrAffiliate')
const AffiliateDashboard = () => import('../components/AffiliateDashboard')
const AffiliateAccount = () => import('../components/AffiliateAccount')
const AffiliateCodes = () => import('../components/AffiliateCodes')
const newAffiliateCode = () => import('../components/newAffiliateCode')
const editAffiliateCode = () => import('../components/editAffiliateCode')
const billing = () => import('../components/billing.vue')
const plans = () => import('../components/plans')
const accountHome = () => import('../components/accountsHome')
const videoPage = () => import('../components/videoPage')
const ViralShare = () => import('../components/ViralShare')
const AffiliateResources = () => import('../components/AffiliateResources')
const AffiliateBilling = () => import('../components/AffiliateBilling')
const Marketplace = () => import('../components/Marketplace')
const editMarketProduct = () => import('../components/editMarketProduct')
const Cart = () => import('../components/Cart')
const JtvShortUrls = () => import('../components/JtvShortUrls')
const TextMessagesSetup = () => import('../components/TextMessagesSetup')
const paymentSources = () => import('../components/paymentSources')
const BusinessSmsNumbers = () => import('../components/BusinessSmsNumbers')
const Users = () => import('../components/Users')
const AccountsManagement = () => import('../components/AccountsManagement')
const ChooseAccount = () => import('../components/ChooseAccount')
const Roles = () => import('../components/Roles')
const AddRole = () => import('../components/AddRole')
const EditRole = () => import('../components/EditRole')
const MediaManager = () => import('../components/MediaManager')
const QuillEditor = () => import('../components/QuillEditor')
const DirectoryListingsManagement = () => import('../components/DirectoryListing')
const newDirectoryListingItem = () => import('../components/newDirectoryListingItem')
const editDirectoryListingItem = () => import('../components/editDirectoryListingItem')
const resourcesDirectory = () => import('../components/ResourcesDirectory')
const resourcesDirectoryItem = () => import('../components/resourceDirectoryItem')
const topBarCampaigns = () => import('../components/topBarCampaigns')
const newTopBarCampaigns = () => import('../components/newTopBarCampaigns')
const editTopBarCampaigns = () => import('../components/editTopBarCampaigns')
const TopBarReports = () => import('../components/TopBarReports')
const AffiliateFlayers = () => import('../components/AffiliateFlyers')
const StaffPages = () => import('../components/StaffPages')
const onboarding = () => import('../components/onboarding')
const StaffRewards = () => import('../components/StaffRewards')
const NCV = () => import('../components/NcvPage')
const PosterMyWall = () => import('../components/posterMyWall')
const OwnerFlyers = () => import('../components/OwnersFlyers')
const CheckBox = () => import('../components/CheckBox')
const GiftCardEvergreen = () => import('../components/GiftCardEvergreen')

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld,
      beforeEnter: (to, from, next) => {
        next('/dashboard')
      }

    },
    {
      path: '/login',
      name: 'loginPage',
      component: login
    },
    {
      path: '/recover-password',
      name: 'recoverPassord',
      component: forgotPassword
    },
    {
      path: '/register',
      name: 'registerPage',
      component: register
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: dashboard,
      beforeEnter: guardRoute,
      meta: {permissions: 'view_dashboard'}
    },
    {
      path: '/account',
      name: 'account',
      component: accountHome,
      beforeEnter: guardRouteAccount,
      children: [
        {
          path: 'profile',
          name: 'profile',
          component: account,
          beforeEnter: guardRouteAccount

        },
        {
          path: 'billing',
          name: 'billing',
          component: billing,
          beforeEnter: guardRouteAccount,
          meta: {permissions: 'view_dashboard'}
        },
        {
          path: 'plans',
          name: 'plans',
          component: plans,
          beforeEnter: guardRouteAccount,
          meta: {permissions: 'view_dashboard'}
        },
        {
          path: 'business-sms-numbers',
          name: 'BusinessSmsNumbers',
          component: BusinessSmsNumbers,
          beforeEnter: guardRouteAccount
        },
        {
          path: '/payment-sources',
          name: 'paymentSources',
          component: paymentSources,
          beforeEnter: guardRouteAccount,
          meta: {permissions: 'view_dashboard'}
        },
        {
          path: '/account/management',
          name: 'AccountsManagement',
          component: AccountsManagement,
          beforeEnter: guardRouteAccount
        }

      ]
    },
    {
      path: '/page-setup',
      name: 'pageSetup',
      component: pageSetup,
      beforeEnter: guardRoute,
      meta: {permissions: 'view_opt_in_pages'}
    },

    {
      path: '/fast-start-marketing',
      name: 'OwnerFlyers',
      component: OwnerFlyers,
      beforeEnter: guardRoute,
      meta: {permissions: 'view_opt_in_pages'}
    },

    {
      path: '/keywords',
      name: 'vipStatus',
      component: vipStatus,
      beforeEnter: guardRoute,
      meta: {permissions: 'view_keywords'}
    },
    {
      path: '/offers',
      name: 'promotions',
      component: promotions,
      beforeEnter: guardRoute,
      meta: {permissions: 'view_offers'}
    },
    {
      path: '/text-messages',
      name: 'campaigns',
      component: campaigns,
      beforeEnter: guardRoute,
      meta: {permissions: 'view_text_message_list'}
    },
    {
      path: '/new-text-messages',
      name: 'newCampaign',
      component: newCampaign,
      beforeEnter: guardRoute,
      meta: {permissions: 'edit_text_message_list'}
    },
    {
      path: '/edit-text-messages/:id',
      name: 'editCampaign',
      component: editCampaign,
      beforeEnter: guardRoute,
      meta: {permissions: 'view_text_message_list'}
    },
    {
      path: '/permanent-campaigns',
      name: 'PermanentCampaigns',
      component: PermanentCampaigns,
      beforeEnter: guardRoute,
      meta: {permissions: 'view_permanent_campaigns'}
    },
    {
      path: '/vip-list',
      name: 'clients',
      component: clients,
      beforeEnter: guardRoute,
      meta: {permissions: 'view_vip_list'}
    },
    {
      path: '/staff',
      name: 'staff',
      component: Staff,
      beforeEnter: guardRoute,
      meta: {permissions: 'view_staff'}
    },
    {
      path: '/staff-pages',
      name: 'staff-pages',
      component: StaffPages,
      beforeEnter: guardRoute,
      meta: {permissions: 'view_staff'}
    },
    {
      path: '/client/:id',
      name: 'client',
      component: client,
      beforeEnter: guardRoute,
      meta: {permissions: 'view_vip_list'}
    },
    {
      path: '/promotion/:id',
      name: 'promotion',
      component: promotion,
      beforeEnter: guardRoute,
      meta: {permissions: 'view_offers'}
    },
    {
      path: '/promotion_add',
      name: 'addPromotion',
      component: addPromotion,
      beforeEnter: guardRoute,
      meta: {permissions: 'edit_offers'}
    },
    {
      path: '/impersonate/:token/user/:id',
      name: 'impersonate',
      component: impersonate
    },
    {
      path: '/register-flow/:token/user/:id',
      name: 'registerImpersonateCmp',
      component: registerImpersonate
    },
    {
      path: '/incoming-text',
      name: 'SmsReceived',
      component: SmsReceived,
      beforeEnter: guardRoute,
      meta: {permissions: 'view_incoming_text'}
    },
    {
      path: '/review-site-links',
      name: 'ReviewSiteLinks',
      component: ReviewSiteLinks,
      beforeEnter: guardRoute,
      meta: {permissions: 'view_reviews_sites'}
    },
    {
      path: '/star-review-settings',
      name: 'StarReviewSettings',
      component: StarReviewSettings,
      beforeEnter: guardRoute,
      meta: {permissions: 'view_reviews_settings'}
    },
    {
      path: '/reviews',
      name: 'Reviews',
      component: Reviews,
      beforeEnter: guardRoute,
      meta: {permissions: 'view_marketplace'}
    },
    {
      path: '/register-affiliate',
      name: 'Affiliate',
      component: Affiliate
    },
    {
      path: '/owner-or-affiliate',
      name: 'OwnerOrAffiliate',
      component: OwnerOrAffiliate
    },
    {
      path: '/affiliate-dashboard',
      name: 'AffiliateDashboard',
      component: AffiliateDashboard,
      beforeEnter: guardRouteAffiliate
    },
    {
      path: '/affiliate/account',
      name: 'AffiliateAccount',
      component: AffiliateAccount,
      beforeEnter: guardRouteAffiliate
    },
    {
      path: '/affiliate-codes',
      name: 'AffiliateCodes',
      component: AffiliateCodes,
      beforeEnter: guardRouteAffiliate
    },
    {
      path: '/new-code',
      name: 'newAffiliateCode',
      component: newAffiliateCode,
      beforeEnter: guardRouteAffiliate
    },
    {
      path: '/edit-code/:id',
      name: 'editAffiliateCode',
      component: editAffiliateCode,
      beforeEnter: guardRouteAffiliate
    },
    {
      path: '/first-time',
      name: 'videoPage',
      component: videoPage,
      beforeEnter: guardRouteAffiliate
    },
    {
      path: '/resources-listings-management',
      name: 'DirectoryListingsManagement',
      component: DirectoryListingsManagement,
      beforeEnter: guardRouteAffiliate
    },
    {
      path: '/add-resources-listings-item',
      name: 'newDirectoryListingItem',
      component: newDirectoryListingItem,
      beforeEnter: guardRouteAffiliate
    },
    {
      path: '/edit-resources-listings-item/:id',
      name: 'editDirectoryListingItem',
      component: editDirectoryListingItem,
      beforeEnter: guardRouteAffiliate
    },
    {
      path: '/resources-directory',
      name: 'resourcesDirectory',
      component: resourcesDirectory,
      beforeEnter: guardRoute
    },
    {
      path: '/resources-directory/item/:id',
      name: 'resourcesDirectoryItem',
      component: resourcesDirectoryItem,
      beforeEnter: guardRoute
    },
    {
      path: '/viral-share',
      name: 'ViralShare',
      component: ViralShare,
      beforeEnter: guardRoute,
      meta: {permissions: 'view_viral_share'}

    },
    {
      path: '/affiliate-resources',
      name: 'AffiliateResources',
      component: AffiliateResources,
      beforeEnter: guardRouteAffiliate
    },
    {
      path: '/affiliate/billing',
      name: 'AffiliateBilling',
      component: AffiliateBilling,
      beforeEnter: guardRouteAffiliate
    },
    {
      path: '/marketplace',
      name: 'Marketplace',
      component: Marketplace,
      beforeEnter: guardRoute,
      meta: {permissions: 'view_marketplace'}
    },
    {
      path: '/market-product/:id',
      name: 'editMarketProduct',
      component: editMarketProduct,
      beforeEnter: guardRoute,
      meta: {permissions: 'view_marketplace'}
    },
    {
      path: '/cart',
      name: 'Cart',
      component: Cart,
      beforeEnter: guardRoute,
      meta: {permissions: 'view_marketplace'}
    },
    {
      path: '/jtv-short-urls',
      name: 'JtvShortUrls',
      component: JtvShortUrls,
      beforeEnter: guardRoute,
      meta: {permissions: 'view_jtv_short_url'}
    },
    {
      path: '/gift-card-evergreen',
      name: 'GiftCardEvergreen',
      component: GiftCardEvergreen,
      beforeEnter: guardRoute,
      meta: {permissions: 'view_jtv_short_url'}
    },
    {
      path: '/default-setup',
      name: 'TextMessagesSetup',
      component: TextMessagesSetup,
      beforeEnter: guardRoute,
      meta: {permissions: 'view_default_setup'}
    },
    {
      path: '/users',
      name: 'Users',
      component: Users,
      beforeEnter: guardRoute,
      meta: {permissions: 'view_users'}
    },
    {
      path: '/choose-account',
      name: 'ChooseAccount',
      component: ChooseAccount,
      beforeEnter: guardRoute
    },
    {
      path: '/roles',
      name: 'Roles',
      component: Roles,
      beforeEnter: guardRoute,
      meta: {permissions: 'view_roles'}
    },
    {
      path: '/add-role',
      name: 'AddRole',
      component: AddRole,
      beforeEnter: guardRoute,
      meta: {permissions: 'edit_roles'}
    },
    {
      path: '/edit-role/:id',
      name: 'EditRole',
      component: EditRole,
      beforeEnter: guardRoute,
      meta: {permissions: 'edit_roles'}
    },
    {
      path: '/media-manager',
      name: 'MediaManager',
      component: MediaManager,
      beforeEnter: guardRoute
    },
    {
      path: '/quill',
      name: 'QuillEditor',
      component: QuillEditor,
      beforeEnter: guardRoute
    },
    {
      path: '/vip-opt-in-bar',
      name: 'topBarCampaigns',
      component: topBarCampaigns,
      beforeEnter: guardRoute
    },
    {
      path: '/new-vip-opt-in-bar',
      name: 'newTopBarCampaigns',
      component: newTopBarCampaigns,
      beforeEnter: guardRoute
    },
    {
      path: '/vip-opt-in-bar/:id',
      name: 'editTopBarCampaigns',
      component: editTopBarCampaigns,
      beforeEnter: guardRoute

    },
    {
      path: '/vip-opt-in-bar-reports',
      name: 'TopBarReports',
      component: TopBarReports,
      beforeEnter: guardRoute
    },
    {
      path: '/affiliate-flayers',
      name: 'AffiliateFlayers',
      component: AffiliateFlayers,
      beforeEnter: guardRouteAffiliate
    },

    {
      path: '/onboarding',
      name: 'onBoarding',
      component: onboarding,
      beforeEnter: guardRoute
    },
    {
      path: '/staff-rewards',
      name: 'staffRewards',
      component: StaffRewards,
      beforeEnter: guardRoute
    },
    {
      path: '/ncv',
      name: 'NCV',
      component: NCV,
      beforeEnter: guardRoute
    },
    {
      path: '/poster-my-wall',
      name: 'PosterMyWall',
      component: PosterMyWall,
      beforeEnter: guardRoute
    },
    {
      path: '/checklist',
      name: 'CheckBox',
      component: CheckBox,
      beforeEnter: guardRoute
    }

  ]
})

function guardRouteAccount (to, from, next) {
    // work-around to get to the Vuex store (as of Vue 2.0)
  const auth = router.app.$options.store.state.auth

  if (!auth.isLoggedIn) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}

function guardRoute (to, from, next) {
    // work-around to get to the Vuex store (as of Vue 2.0)
  const auth = router.app.$options.store.state.auth

  if (!auth.isLoggedIn) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    // if (!auth.user.stripe_id) {
    //   next({
    //     path: '/account/plans',
    //     query: { redirect: to.fullPath }
    //   })
    //   return

    if (!auth.user.account_id && auth.user.is_affiliate) {
      next({
        path: '/affiliate-dashboard'
      })
      return
    }

    if (auth.user.account_id && !auth.user.account_id.first_time.VideoPage) {
      next({
        path: '/dashboard'
      })
      return
    }

    if (auth.user.account_id && auth.user.account_id.stripe_id && !auth.user.account_id.number) {
      next({
        path: '/account/profile',
        query: { redirect: to.fullPath }
      })
      return
    }
    if (auth.user.account_id && to.meta.permissions) {
      const permissions = to.meta.permissions
      if (!(permissions.length > 0 ? auth.user.permissions.some(r => permissions.includes(r)) : true)) {
        next({
          path: '/account/profile',
          query: { redirect: to.fullPath }
        })
      } else {
        next()
      }
    }

    if (auth.user.account_id && !auth.user.account_id.current_subscription_status && !auth.user.account_id.is_trial && auth.user.account_id.stripe_id) {
      // if (auth.user.first_time) {
      //   next({
      //     path: '/account/plans',
      //     query: {redirect: to.fullPath}
      //   })
      // } else {
      //   next({
      //     path: '/first-time',
      //     query: { redirect: to.fullPath }
      //   })
      // }
      next()
    } else {
      next()
    }
  }
}

function guardRouteAffiliate (to, from, next) {
    // work-around to get to the Vuex store (as of Vue 2.0)
  const auth = router.app.$options.store.state.auth

  if (!auth.isLoggedIn) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js